import { initAckoAnalytics } from '@acko-tech/building-blocks.ui.acko-analytics'
// Update SDK state and its readiness global together. Never execute the SDK's returned string.
// This runs in a client layout effect, before destination page-view passive effects.
export function initializeClientAnalytics(trackerId: string, writeKey: string, cdpApiEndPoint?: string): void {
  initAckoAnalytics(trackerId, writeKey, cdpApiEndPoint)
  const analyticsWindow = window as Window & { acko_analytics?: { write_key: string; anonymousId: string } }
  analyticsWindow.acko_analytics = { write_key: writeKey, anonymousId: trackerId }
}
